import React from 'react';
import {useModalStore} from "@/Stores/Site/ModalStore";
import WhySuchPriceModal from "@/Components/Modal/WhySuchPriceModal";

const PriceComponent = (props) => {
    let {product = {}, productDataCurrent = {}} = props;
    const {marker_discount_color = '', marker_discount_bg_color = ''} = product;

    const {
        price = 0, // Цена
        card_price = 0, // Цена со скидкой
        card_discount = 0, // Скидка
        kol = 0 // Количество
    } = productDataCurrent;

    const openWhySuchPriceModal = useModalStore(state => state.openWhySuchPriceModal);

    const openModal = () => {
        openWhySuchPriceModal();
    }

    return (
        <div className={`priceContainer`}>
            <div className={`priceContainer__price`}>
                <p className={`priceContainer__priceCurrent`}>
                    {card_price.toLocaleString('ru')} ₽
                </p>
                {price !== card_price && (
                    <p className={`priceContainer__priceOld`}>
                        {price.toLocaleString('ru')} ₽
                    </p>
                )}
                {card_discount !== 0 && kol !== 0 && (
                    <p className={`priceContainer__discount`}
                         style={{
                             color: `${marker_discount_color}`,
                             backgroundColor: `${marker_discount_bg_color}`
                         }}
                    >
                        {`-${card_discount}%`}
                    </p>
                )}
                {/*{sale.discount !== 0 && kol !== 0 && (*/}
                {/*    <div className={`priceContainer__discount`}*/}
                {/*         style={{*/}
                {/*             color: `${marker_discount_color}`,*/}
                {/*             backgroundColor: `${marker_discount_bg_color}`*/}
                {/*         }}*/}
                {/*    >*/}
                {/*        {`-${sale.discount}%`}*/}
                {/*    </div>*/}
                {/*)}*/}
            </div>
            {price !== card_price && (
                <>
                    <p className={`priceContainer__text`} onClick={openModal}>
                        Почему такая цена?
                    </p>
                    <WhySuchPriceModal productDataCurrent={productDataCurrent} {...props} />
                </>
            )}
        </div>
    );
}

export default PriceComponent;
